module.exports = __webpack_public_path__ + "h5/img/summer-nav1-1.73921d7b.png";